import React, {ReactNode} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../libs/shared/core/src/models/api/paletteModel';
import {TeammateAvailabilityStatusesEnum} from '../../../libs/shared/core/src/models/api/teammateModel';
import {IconName} from '../../../libs/shared/ui/src/components/icon/icon';

/*
 * Constants.
 */

const teammateStatusConfig: Record<TeammateAvailabilityStatusesEnum, TeammateAvailabilityStatus> = {
  [TeammateAvailabilityStatusesEnum.AVAILABLE]: {
    icon: 'bellTiny',
    text: <Trans id="teammate-availability-status-available">Available</Trans>,
    color: PaletteColorsEnum.GREEN,
  },
  [TeammateAvailabilityStatusesEnum.BUSY]: {
    icon: 'unassignTiny',
    text: <Trans id="teammate-availability-status-busy">Busy</Trans>,
    color: PaletteColorsEnum.YELLOW,
    tooltip: <Trans id="teammate-availability-status-busy-tooltip">Pause new assignments.</Trans>,
  },
  [TeammateAvailabilityStatusesEnum.OUT_OF_OFFICE]: {
    icon: 'oooTiny',
    text: <Trans id="teammate-availability-status-ooo">Out of office</Trans>,
    color: PaletteColorsEnum.RED,
    tooltip: (
      <Trans id="teammate-availability-status-ooo-tooltip">
        Mute notifications, pause new assignments, unassign conversations with new activity.
      </Trans>
    ),
  },
};

/*
 * Types.
 */

type TeammateAvailabilityStatus = {
  icon: IconName;
  text: ReactNode;
  color: PaletteColorsEnum;
  tooltip?: ReactNode;
};

/*
 * Helpers.
 */

export function computeTeammateAvailabilityValues(status: TeammateAvailabilityStatusesEnum) {
  return teammateStatusConfig[status];
}
